module.exports = __webpack_public_path__ + "media/images/photo03-d21f4e31a8eddd0b12fd3d9c5de4e11b.png";